import { Coin } from './coin';
import { FiatTransactionStatus } from './fiat-transaction-status';
import { Bank } from './bank';
import { SystemPart } from './system-part';
import { Currency } from './currency';
import { SeverityLevel } from './severity-level';

export interface IFiatDeposit {
    id: string;
    code: string;
    amount: Coin;
    amountFee: Coin;
    type: FiatDepositType;
    typeName: string;
    dateCreated: string;
    dateDone: string;
    dateCanceled: string;
    status: FiatTransactionStatus;
    statusNote: string;
    cashbackBonus: FiatDeposit;
    penalty: FiatDepositPenalty;
    cancelable: boolean;
    origin: SystemPart;
}

export interface FiatDeposit extends IFiatDeposit {
    recipientBank?: Bank;
    transferReference?: string;
    dateReceived?: string;
    transferId?: string;
    description?: String;
    note?: String;
    gatewayTransactionId?: string;
    amountPaid?: Coin;
    transactionReference?: FiatDepositWire;
    additionalProviderData?: AdditionalProviderData;
    isTransferReceiptRequired: boolean;
    gatewayFailureMessage: string;
}

export interface FiatDepositWire extends IFiatDeposit {
    recipientBank: Bank;
    transferReference: string;
    dateReceived: string;
    transferId: string;
}

export interface FiatDepositLean extends IFiatDeposit {
    recipientBank: Bank;
    transferReference: string;
    dateReceived: string;
    transferId: string;
}

export interface FiatDepositBonus extends IFiatDeposit {
    description: String;
    note: String;
}

export interface FiatDepositCreditCard extends IFiatDeposit {
    transferId: string;
    dateReceived: string;
    gatewayTransactionId: string;
    amountPaid: Coin;
    additionalProviderData: AdditionalProviderData;
    gatewayFailureMessage: string;
}

// tslint:disable-next-line: no-empty-interface
export interface IAdditionalProviderData {}

export interface PaytabsAdditionalData extends IAdditionalProviderData {
    provider: OnlinePaymentProvider;
    environment: ProviderEnvironment;
}
export interface HyperPayAdditionalData extends IAdditionalProviderData {
    provider: OnlinePaymentProvider;
    environment: ProviderEnvironment;
    widgetUrl: string;
}
export interface SafeChargeAdditionalData extends IAdditionalProviderData {
    provider: OnlinePaymentProvider;
    environment: ProviderEnvironment;
    gatewayUrl: string;
    parameterString: string;
    method: string;
}

export interface CheckoutAdditionalData extends IAdditionalProviderData {
    provider: OnlinePaymentProvider;
    environment: ProviderEnvironment;
    publicKey: string;
}

export interface AdditionalProviderData extends IAdditionalProviderData {
    provider?: OnlinePaymentProvider;
    environment: ProviderEnvironment;
    gatewayUrl?: string;
    parameterString?: string;
    method?: string;
    widgetUrl?: string;
    publicKey: string;
}

// tslint:disable-next-line:no-empty-interface
export interface FiatDepositReferralReward extends IFiatDeposit {}

export interface FiatDepositKnet extends IFiatDeposit {
    transferId: string;
    dateReceived: string;
}

export interface FiatDepositCash extends IFiatDeposit {
    transferId: string;
    dateReceived: string;
    recipientBank: Bank;
}

export interface FiatDepositCorrection extends IFiatDeposit {
    note: string;
    transactionReference: FiatDepositWire;
}

export interface FiatDepositPenalty {
    amount: Coin;
    description: string;
}

export interface FiatDepositTypeInfo {
    type: FiatDepositType;
    supportedCurrencies: Currency[];
}

export interface PaymentTypeInfo {
    type: PaymentType;
    supportedCurrencies: Currency[];
    bankDetailsRequired: boolean;
    providers: OnlinePaymentProvider[];
    notes: PaymentTypeInfoNote[];
    isInstantDepositAvailable: boolean;
}

export interface PaymentTypeInfoNote {
    severity: SeverityLevel;
    text: string;
}

export interface PaymentGatewayConfirmationInput {
    type: PaymentGatewayConfirmationInputType;
    checkoutToken?: CheckoutTokenInput
    checkoutStoredCard?: CheckoutStoredCardInput
}
export interface CheckoutTokenInput {
    token: string;
}
export interface CheckoutStoredCardInput {
    id: number;
    cvv: string;
}

export interface FiatCreditCardDepositRedirectResponse {
    url: string;
    successUrl?: string;
    failureUrl?: string;
}

export enum FiatDepositType {
    WIRE = 'WIRE',
    BONUS = 'BONUS',
    CREDIT_CARD = 'CREDIT_CARD',
    REFERRAL_REWARD = 'REFERRAL_REWARD',
    KNET = 'KNET',
    CASH = 'CASH',
    CORRECTION = 'CORRECTION'
}

export enum PaymentType {
    WIRE = 'WIRE',
    CASH = 'CASH',
    KNET = 'KNET',
    CREDIT_CARD = 'CREDIT_CARD',
    LEAN = 'LEAN'
}

export enum OnlinePaymentProvider {
    PAYTABS = 'PAYTABS',
    HYPERPAY = 'HYPERPAY',
    SAFECHARGE = 'SAFECHARGE',
    CHECKOUT = 'CHECKOUT'
}

export enum ProviderEnvironment {
    TEST = 'TEST',
    PRODUCTION = 'PRODUCTION'
}

export enum PaymentGatewayConfirmationInputType {
    CHECKOUT_TOKEN = 'CHECKOUT_TOKEN',
    CHECKOUT_STORED_CARD = 'CHECKOUT_STORED_CARD'
}

export interface FiatDepositFee {
    fee: Coin;
    amount: Coin;
    totalAmount: Coin;
}
